import { render, staticRenderFns } from "./CarrosselStepBanners.vue?vue&type=template&id=f653bd40&scoped=true&"
import script from "./CarrosselStepBanners.vue?vue&type=script&lang=js&"
export * from "./CarrosselStepBanners.vue?vue&type=script&lang=js&"
import style0 from "./CarrosselStepBanners.vue?vue&type=style&index=0&id=f653bd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f653bd40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow})
